import { canPerformAction, type WorkAccessProfile } from "./access";

export function canStartWorkOrderFromAsset(
  kind: "ASSET" | "LOCATION" | null | undefined,
  profile: WorkAccessProfile | null | undefined,
) {
  return Boolean(
    (kind === "ASSET" || kind === "LOCATION") &&
      profile &&
      canPerformAction(profile, "CREATE_WORK_ORDER"),
  );
}
